import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { hasChildren } from "../../../utils/hasChildren";
import GenerateIcon from "../../global/GenerateIcon";

export default function Menu({ data, rootURL }) {
    return data.map((item, key) => <MenuItem key={key} item={item} rootURL={rootURL} />);
}

const MenuItem = ({ item, rootURL }) => {
    const Component = hasChildren(item) ? MultiLevel : SingleLevel;
    return <Component item={item} rootURL={rootURL} />;
};

const SingleLevel = ({ item, rootURL }) => {
    const location = useLocation();
    // console.log("this is submenu item", item, rootURL + '/' + item.url)
    return (
        <RouterLink to={item.url} style={{
            color: 'inherit',
            fontSize: '14px',
            fontWeight: '500'
            // borderBottom: '2px solid grey'
        }}>
            <ListItem button
                key={item.id}
                selected={rootURL + '/' + item.url === location.pathname}
            >
                <ListItemIcon>{GenerateIcon(item.icon && item.icon !== null ? item.icon : null)}</ListItemIcon>
                <ListItemText primary={item.title} />
            </ListItem>
        </RouterLink>
    );
};

const MultiLevel = ({ item, rootURL }) => {
    const { items: children } = item;
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    return (
        <React.Fragment>
            <ListItem
                key={item.id}
                button onClick={handleClick}>
                <ListItemIcon>{GenerateIcon(item.icon && item.icon !== null ? item.icon : null)}</ListItemIcon>
                <ListItemText primary={item.title} />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {children.map((child, key) => (
                        <MenuItem key={key} item={child} rootURL={rootURL} />
                    ))}
                </List>
            </Collapse>
        </React.Fragment>
    );
};
